import {MyopMessages} from "../../common/MyopMessages";
import {ExecuteScriptMessage, MutationObserverMessage} from "../../messages";
import {BaseMessageHandler} from "../../common";
import {observeDOM} from "../../common/utils/domObserver";

export class SetMutationObserverHandler extends BaseMessageHandler<ExecuteScriptMessage> {
    messageType = MyopMessages.SetMutationObserverMessage

    executor = (event: ExecuteScriptMessage) => {
        if (event.source) {
            observeDOM(document.body, () => {
                this.messageToHost(new MutationObserverMessage()
                    //  new EnvelopedMessage(event.source!, new MutationObserverMessage())
                )
            })
        }
    }
}
